export const datepicker = {
  root: {
    transitionDuration: "{transition.duration}",
  },
  panel: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
    shadow: "{overlay.popover.shadow}",
    padding: "{padding.12}",
  },
  header: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    padding: "0 0 {padding.8} 0",
  },
  title: {
    gap: "{gap.8}",
    fontWeight: "500",
  },
  dropdown: {
    width: "{form.field.icon.size}",
    // sm: {
    //   width: "2rem",
    // },
    // lg: {
    //   width: "3rem",
    // },
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.border.color}",
    activeBorderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  inputIcon: {
    color: "{form.field.icon.color}",
  },
  selectMonth: {
    hoverBackground: "{content.hover.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    padding: "{0.25rem 0.5rem}",
    borderRadius: "{content.border.radius}",
  },
  selectYear: {
    hoverBackground: "{content.hover.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    padding: "0.25rem 0.5rem",
    borderRadius: "{content.border.radius}",
  },
  group: {
    borderColor: "{content.border.color}",
    gap: "{overlay.popover.padding}",
  },
  dayView: {
    margin: "0.5rem 0 0 0",
  },
  weekDay: {
    padding: "0.25rem",
    fontWeight: "500",
    color: "{content.color}",
  },
  date: {
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{primary.support}",
    rangeSelectedBackground: "{highlight.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{color.white}",
    rangeSelectedColor: "{highlight.color}",
    width: "2rem",
    height: "2rem",
    borderRadius: "50%",
    padding: "0.25rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  monthView: {
    margin: "0.5rem 0 0 0",
  },
  month: {
    padding: "0.375rem",
    borderRadius: "{content.border.radius}",
  },
  yearView: {
    margin: "0.5rem 0 0 0",
  },
  year: {
    padding: "0.375rem",
    borderRadius: "{content.border.radius}",
  },
  buttonbar: {
    padding: "0.5rem 0 0 0",
    borderColor: "{content.border.color}",
  },
  timePicker: {
    padding: "0.5rem 0 0 0",
    borderColor: "{content.border.color}",
    gap: "0.5rem",
    buttonGap: "0.25rem",
  },
  extend: {
    ui: {
      hoverColor: "{primary.support}",
    },
  },
  colorScheme: {
    light: {
      dropdown: {
        // background: "{surface.100}",
        // hoverBackground: "{surface.200}",
        // activeBackground: "{surface.300}",
        color: "{form.field.icon.color}",
        // hoverColor: "{surface.700}",
        // activeColor: "{surface.800}",
      },
      today: {
        background: "{content.hover.background}",
        color: "{content.color}",
      },
    },
    dark: {
      dropdown: {
        // background: "{surface.100}",
        // hoverBackground: "{surface.200}",
        // activeBackground: "{surface.300}",
        color: "{form.field.icon.color}",
        // hoverColor: "{surface.700}",
        // activeColor: "{surface.800}",
      },
      today: {
        background: "{content.hover.background}",
        color: "{content.color}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-datepicker input:enabled:hover {
      border-color: ${dt("datepicker.extend.ui.hover.color")};
    }
    .p-datepicker input:focus {
      border-color: ${dt("datepicker.extend.ui.hover.color")};
    }

  `,
};
